/* app/js/src/components/live/liveSwitcher.component/liveSwitcher.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  padding: 0 4em;
  display: block;
  position: relative;
}
:host > div {
  overflow: visible;
  height: 47px;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
:host > div button {
  background-color: #ffffff;
  border: none;
  height: 47px;
  width: 47px;
  border-radius: 50%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
:host > div button svg {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
:host > div button:focus {
  outline: none;
}
:host > div button:last-child {
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -ms-transform: translateY(0px);
  -webkit-transform: translateY(0px);
  transform: translateY(0px);
  -webkit-box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0);
  -moz-box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0);
  box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0);
  position: absolute;
  opacity: 0;
  z-index: -1;
}
:host.switchOptionsIsActive > div button:last-child {
  -ms-transform: translateY(10px);
  -webkit-transform: translateY(10px);
  transform: translateY(10px);
  -webkit-box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0.27);
  -moz-box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0.27);
  box-shadow: 0px 2px 10px 0 rgba(135, 155, 175, 0.27);
  opacity: 1;
  z-index: 10;
}
:host.switchOptionsIsActive .small-button svg path {
  -ms-transform: rotate(180deg) translateY(1px);
  -webkit-transform: rotate(180deg) translateY(1px);
  transform: rotate(180deg) translateY(1px);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.small-button {
  width: 16px;
  height: 16px;
  background-color: #e1e6eb;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 7.5px);
  right: calc(50% - 45px);
  border: none;
  text-align: center;
  padding: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.small-button svg path {
  fill: rgb(135, 155, 175);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.small-button:focus {
  outline: none;
}
.small-button:hover {
  background-color: #232f3a;
}
.small-button:hover svg path {
  fill: #ffffff;
}
/*# sourceMappingURL=liveSwitcher.component.css.map */
